@use "../../../theme/iconMixin";

.container {
	display: inline-block;
	position: relative;
}

.input {
	display: none;
}

.label {
	float: right;
	cursor: default;
}

.editable {
	cursor: pointer;
}

.star {
	display: block;
	width: 31px;
	height: 31px;
	margin: 0 6px;
	@include iconMixin.icon('../../../assets/star.svg');

	&.active {
		@include iconMixin.icon('../../../assets/star-filled.svg');
	}
}

@media screen and (max-width: 480px) {
	.star {
		width: 40px;
		height: 40px;
	}
}
